import { render, staticRenderFns } from "./ModalLuxOutputRuleEdit.vue?vue&type=template&id=b5fb8e4e&scoped=true"
import script from "./ModalLuxOutputRuleEdit.vue?vue&type=script&lang=js"
export * from "./ModalLuxOutputRuleEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalLuxOutputRuleEdit.vue?vue&type=style&index=0&id=b5fb8e4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fb8e4e",
  null
  
)

export default component.exports